import { LoanStatuses } from '@app/configs/loanApplication';
const STATUS_VARIANT_MAP = {
    [LoanStatuses.Active]: 'success',
    [LoanStatuses.Invested]: 'success',
    [LoanStatuses.Returned]: 'success',
    [LoanStatuses.Paid]: 'success',
    [LoanStatuses.Overdue]: 'warning',
    [LoanStatuses.Expired]: 'critical',
    [LoanStatuses.Confirmed]: 'alert',
    [LoanStatuses.Cancelled]: 'disabled',
    [LoanStatuses.Canceled]: 'disabled',
};
export const getInvestmentStatusVariant = (status) => { var _a; return (_a = STATUS_VARIANT_MAP[status.toLowerCase()]) !== null && _a !== void 0 ? _a : null; };
